import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon } from 'design-react-kit';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';

class EsportaAfferentiToolbar extends Component {
    hasPermissions() {
        const { actions } = this.props;
        return actions?.user?.some((ua) => ua?.id === 'toolbar-esporta-afferenti');
    }

    getCurrentPath() {
        const { breadcrumbs } = this.props;
        return breadcrumbs.length > 0
            ? breadcrumbs[breadcrumbs.length - 1]?.url
            : '/';
    }

    handleClick = (e) => {
        e.preventDefault();

        const currentPath = this.getCurrentPath();
        const csv_endpoint = '@getStrutturaAfferentiCSV';
        const csv_url_api =
            `/++api++/${csv_endpoint}?struttura_path=${encodeURIComponent(currentPath)}`;

        window.location.href = csv_url_api;
    };

    render() {
        if (!this.hasPermissions()) return null;

        const { intl } = this.props;
        const toolbar_title = intl.formatMessage({ id: 'esporta_afferenti' });

        return (
            <Plug pluggable="main.toolbar.top" id="esporta-afferenti-toolbar">
                <Link
                    to="#"
                    onClick={this.handleClick}
                    aria-label={toolbar_title}
                    tabIndex={0}
                    className="deleteBlocks"
                    id="toolbar-esporta-afferenti"
                >
                    <Icon
                        icon="it-download"
                        color="secondary"
                        size="md"
                        title={toolbar_title}
                        alt={toolbar_title}
                    />
                </Link>
            </Plug>
        );
    }
}

const mapStateToProps = (state) => ({
    actions: state?.actions?.actions,
    breadcrumbs: state.breadcrumbs.items || [],
});

export default injectLazyLibs(['toastify'])(
    connect(
        mapStateToProps
    )
        (injectIntl(
            EsportaAfferentiToolbar
        ))
);